import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { fuseAnimations } from '@fuse/animations';
import { PlayVideoComponent } from 'app/shared/common/play-video/play-video.component';

@Component({
  selector: 'app-demo-videos',
  templateUrl: './demo-videos.component.html',
  styleUrls: ['./demo-videos.component.scss'],
  animations: fuseAnimations
})
export class DemoVideosComponent implements OnInit {

  videoList = [
    {
      title: 'Clients create & update',
      description: 'In clients we are displaying how to create the clients',
      url: 'https://erp.whatsdare.com/videos/clients-create-and-update.mp4',
      image: 'assets/images/demo-videos/clients-create-update.jpg',
    },
    {
      title: 'Onboarding Project',
      description: 'Here we are showing the how to create a project in Opnworx',
      url: 'https://erp.whatsdare.com/videos/onboarding-project.mp4',
      image: 'assets/images/demo-videos/onboarding-project.jpg',
    },
    {
      title: 'Project Add & Release Resource',
      description: 'Here we are showing how to add/release the resource in the project',
      url: 'https://erp.whatsdare.com/videos/add-remove-resource.mp4',
      image: 'assets/images/demo-videos/add-remove-resource.jpg',
    },
    {
      title: 'Register Employee',
      description: 'In this we are showing how to create an employee in Opnworx',
      url: 'https://erp.whatsdare.com/videos/add-employee-details.mp4',
      image: 'assets/images/demo-videos/add-employee.jpg',
    },
    {
      title: 'Employees details',
      description: 'Here we are displaying employees personal details, official details, list of projects assigned, experience details, violation histories and settings in Opnworx',
      url: 'https://erp.whatsdare.com/videos/employees-details.mp4',
      image: 'assets/images/demo-videos/employees-details.jpg',
    },
    {
      title: 'Released, Long leave employees & Employees experiences',
      description: 'Released, Long leave employees & Employees experiences',
      url: 'https://erp.whatsdare.com/videos/released-long-leave-and-employees-experiences.mp4',
      image: 'assets/images/demo-videos/released-long-leave-employees-experiences.jpg',
    },
    {
      title: 'Backlogs',
      description: 'Here we are showing how to create a backlogs in Opnworx',
      url: 'https://erp.whatsdare.com/videos/backlogs.mp4',
      image: 'assets/images/demo-videos/backlogs.jpg',
    },
    {
      title: 'Bigboss',
      description: 'Here we are showing the Opnworx desktop application login',
      url: 'https://erp.whatsdare.com/videos/bigboss.mp4',
      image: 'assets/images/demo-videos/bigboss.jpg',
    },
    {
      title: 'Allocate task in Opnworx',
      description: 'Here we are showing how to allocate a task in Opnworx',
      url: 'https://erp.whatsdare.com/videos/allocate-task-in-g360.mp4',
      image: 'assets/images/demo-videos/allocate-task.jpg',
    },
    {
      title: 'Hold and Completed',
      description: 'Here we are showing how to hold the task and complete the task',
      url: 'https://erp.whatsdare.com/videos/hold-completed.mp4',
      image: 'assets/images/demo-videos/hold-complete.jpg',
    },
    {
      title: 'Creating To do',
      description: 'Here we are showing how to create a to do in Opnworx',
      url: 'https://erp.whatsdare.com/videos/creating-todo.mp4',
      image: 'assets/images/demo-videos/create-todo.jpg',
    },
    {
      title: 'To do in Opnworx',
      description: 'Here we are showing how to allocate and start the to do in Opnworx',
      url: 'https://erp.whatsdare.com/videos/todo-in-g360.mp4',
      image: 'assets/images/demo-videos/todo-in-g360.jpg',
    },
    {
      title: 'Work carry over',
      description: 'If you hold your current inprogress task the work hours carry over to the next day',
      url: 'https://erp.whatsdare.com/videos/work-carryover.mp4',
      image: 'assets/images/demo-videos/work-carryover.jpg',
    },
    {
      title: 'Break Screen',
      description: 'Here we showing the break screen in Opnworx. When employees going to idle for 5 minutes means, it will open and ask for a reason like internal meetings, personal break',
      url: 'https://erp.whatsdare.com/videos/break-screen.mp4',
      image: 'assets/images/demo-videos/break-screen.jpg',
    },
    {
      title: 'Attendance',
      description: 'Here we are showing the day and monthly attendance in Opnworx',
      url: 'https://erp.whatsdare.com/videos/attendance.mp4',
      image: 'assets/images/demo-videos/attendance.jpg',
    },
    {
      title: 'My Team',
      description: 'Here we showing the list of reporting persons of the current user(TL and Admin). Where you can see your team members timesheet, screenshots, violations, resource status and activities',
      url: 'https://erp.whatsdare.com/videos/my-team.mp4',
      image: 'assets/images/demo-videos/my-team.jpg',
    },
    {
      title: 'Calendar',
      description: 'In calendar we are displayig official holidays and employees leaves, permissions',
      url: 'https://erp.whatsdare.com/videos/calendar.mp4',
      image: 'assets/images/demo-videos/calendar.jpg',
    },
    {
      title: 'My Leaves',
      description: 'Here we are showing the current user applied leaves.',
      url: 'https://erp.whatsdare.com/videos/my-leave.mp4',
      image: 'assets/images/demo-videos/my-leaves.jpg',
    },
    {
      title: 'Team Leaves',
      description: 'In Team Leaves we are showing the number of days leave taken for each employees',
      url: 'https://erp.whatsdare.com/videos/team-leaves.mp4',
      image: 'assets/images/demo-videos/team-leaves.jpg',
    },
    {
      title: 'Holidays',
      description: 'Here we are displaying the list of official office holidays. This holidays list shown in the calendar',
      url: 'https://erp.whatsdare.com/videos/holidays.mp4',
      image: 'assets/images/demo-videos/holidays.jpg',
    },
    {
      title: 'Leave and Permissions',
      description: 'Here we are showing how to apply leave and permission in Opnworx',
      url: 'https://erp.whatsdare.com/videos/leave-permissions.mp4',
      image: 'assets/images/demo-videos/leave-permission.jpg',
    },
    {
      title: 'Project metrics',
      description: 'Here we are displaying the project wise metrics, how many employees are in work, idle, logged out and not yet login',
      url: 'https://erp.whatsdare.com/videos/project-metrics.mp4',
      image: 'assets/images/demo-videos/project-metrics.jpg',
    },
    {
      title: 'Work status',
      description: 'Here we are displaying the how many employees are in work, idle, logged out and not yet login',
      url: 'https://erp.whatsdare.com/videos/work-status.mp4',
      image: 'assets/images/demo-videos/work-status.jpg',
    },
    {
      title: 'Task metrics',
      description: 'In this module we are displaying the employees work estimated hours and actual hours of the week',
      url: 'https://erp.whatsdare.com/videos/task-metrics.mp4',
      image: 'assets/images/demo-videos/task-metrics.jpg',
    },
    {
      title: 'Notifications & Violations',
      description: 'Here showing how to clear the violations, and you can see your notifications',
      url: 'https://erp.whatsdare.com/videos/notification-violation.mp4',
      image: 'assets/images/demo-videos/notification-violation.jpg',
    },
    {
      title: 'Violations',
      description: 'In this module we are displaying the violations. If employees work hours less than 8 hours means it creates incompleted hours violation. If employees break hours greater than 4 hours means it creates incompleted hours violation.',
      url: 'https://erp.whatsdare.com/videos/violations.mp4',
      image: 'assets/images/demo-videos/violations.jpg',
    },
    {
      title: 'Resource analytics & Timesheet report',
      description: 'In resource anlytics displaying the how many employees are dedicated billable, fixed billable and non billable on the selected day. In timesheet report displaying the timesheet rank, which is calculated based on Opnworx work hours',
      url: 'https://erp.whatsdare.com/videos/resource-analytics-and-timesheet-report.mp4',
      image: 'assets/images/demo-videos/resource-analytics-timesheet-report.jpg',
    },
    {
      title: 'Performance Review',
      description: 'In performance module you can review the particual employees of the last 6 months',
      url: 'https://erp.whatsdare.com/videos/performance-review.mp4',
      image: 'assets/images/demo-videos/performance-review.jpg',
    },
    {
      title: 'Activity Center',
      description: 'In Activity Center we are displaying the project, client, addons and employees module activities.',
      url: 'https://erp.whatsdare.com/videos/activity-center.mp4',
      image: 'assets/images/demo-videos/activity-center.jpg',
    },
    {
      title: 'Support',
      description: 'In this module anyone can apply their support like IT Supports, Network issue, OS issue, Hardware issue, Change OS, Software issue, Git permission, etc..',
      url: 'https://erp.whatsdare.com/videos/support.mp4',
      image: 'assets/images/demo-videos/support.jpg',
    },
  ]
  searchValue = '';
  demoVideos = [];

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.demoVideos = this.videoList;
  }

  playVideo(url) {
    const dialogRef = this.dialog.open(PlayVideoComponent, {
      width: '800px',
      height: '560px',
      data: url
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  searchVideo() {
    if (this.searchValue != '') {
      var value = this.searchValue.charAt(0).toUpperCase() + this.searchValue.slice(1);
      var filtered = this.videoList.filter(p => (p.title).startsWith(value));
      this.demoVideos = filtered;
    }
    else {
      this.demoVideos = this.videoList;
    }
  }

}
